import { c as _c } from "react/compiler-runtime";
import IconFriend from '@/components/assets/icon_friend.svg';
import IconNotification from '@/components/assets/icon_notification.svg';
import IconNotificationOutline from '@/components/assets/icon_notification_outline.svg';
import ViverseButton from '@/components/ViverseButton';
import { useToggleFollow } from '@/hooks/useToggleFollow';
import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';
import { useIsClient } from 'usehooks-ts';
type ResponsiveActionButtonProps = {
  icon: ReactNode;
  text?: string;
  onClick?: () => void;
  variant?: 'secondary' | 'filter';
  disabled?: boolean;
  desktopWidth?: string;
};
const ResponsiveActionButton = t0 => {
  const $ = _c(15);
  const {
    icon,
    text,
    onClick,
    variant: t1,
    disabled
  } = t0;
  const variant = t1 === undefined ? "secondary" : t1;
  let t2;
  if ($[0] !== text) {
    t2 = text && <span className="text-vive-primary-20 buttonS-omni-styles">{text}</span>;
    $[0] = text;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== disabled || $[3] !== icon || $[4] !== onClick || $[5] !== t2 || $[6] !== variant) {
    t3 = <ViverseButton className="hidden h-8.5 w-fit min-w-0 gap-1 px-4 py-1 md:inline-flex landscape:hidden" onClick={onClick} variant={variant} disabled={disabled}>{icon}{t2}</ViverseButton>;
    $[2] = disabled;
    $[3] = icon;
    $[4] = onClick;
    $[5] = t2;
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== disabled || $[9] !== icon || $[10] !== onClick) {
    t4 = <ViverseButton className="flex min-w-fit gap-2 p-[7px] md:hidden landscape:inline-flex" variant="icon3" onClick={onClick} disabled={disabled}>{icon}</ViverseButton>;
    $[8] = disabled;
    $[9] = icon;
    $[10] = onClick;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export function FollowButton(t0) {
  const $ = _c(7);
  const {
    showFollowButton
  } = t0;
  const t = useTranslations();
  const {
    isFollowed,
    isButtonEnabled,
    handleToggleFollow
  } = useToggleFollow();
  const isClient = useIsClient();
  let t1;
  if ($[0] !== handleToggleFollow || $[1] !== isButtonEnabled || $[2] !== isClient || $[3] !== isFollowed || $[4] !== showFollowButton || $[5] !== t) {
    t1 = showFollowButton ? <ResponsiveActionButton icon={isFollowed ? <IconNotification className="[&>path]:fill-vive-primary-20 size-5" /> : <IconNotificationOutline className="[&>path]:stroke-vive-primary-20 size-5" />} text={t(`profile-page.intro-${isFollowed ? "unfollow" : "follow"}-action`)} onClick={handleToggleFollow} variant="secondary" disabled={!isButtonEnabled || !isClient} desktopWidth="w-[98px]" /> : null;
    $[0] = handleToggleFollow;
    $[1] = isButtonEnabled;
    $[2] = isClient;
    $[3] = isFollowed;
    $[4] = showFollowButton;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
export const TipButton = () => {
  const $ = _c(5);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconFriend className="[&>path]:fill-vive-primary-20 size-5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("world-info.tip-button");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <ResponsiveActionButton icon={t0} text={t1} variant="secondary" />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};